import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './AICreditsModal.css'

// App-level modal for the "out of AI credits" case. Listens for the
// 'ai-credits-exceeded' event dispatched by the shared axios interceptors
// (src/lib/api.jsx, src/lib/axios.js) whenever an interactive AI call
// returns 402 { error: "LIMIT_EXCEEDED", resource: "ai_credits" }.
export default function AICreditsModal() {
  const [detail, setDetail] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const onExceeded = (e) => setDetail(e.detail || {})
    window.addEventListener('ai-credits-exceeded', onExceeded)
    return () => window.removeEventListener('ai-credits-exceeded', onExceeded)
  }, [])

  if (!detail) return null

  const close = () => setDetail(null)
  const upgradeUrl = detail.upgrade_url || '/settings?section=billing'

  const goToUpgrade = () => {
    close()
    if (upgradeUrl.startsWith('/')) {
      navigate(upgradeUrl)
    } else {
      window.location.href = upgradeUrl
    }
  }

  return (
    <div className="aic-backdrop" onClick={close}>
      <div className="aic-modal" onClick={(e) => e.stopPropagation()}>
        <h2>Out of AI credits</h2>
        <p className="aic-sub">
          {detail.used != null && detail.limit != null
            ? `You've used ${detail.used} of ${detail.limit} AI credits this period.`
            : "You've reached your AI credits limit for this period."}
          {' '}Upgrade your plan to keep using AI features.
        </p>
        <div className="aic-actions">
          <button className="aic-btn-ghost" onClick={close}>Dismiss</button>
          <button className="aic-btn-primary" onClick={goToUpgrade}>Upgrade Plan</button>
        </div>
      </div>
    </div>
  )
}
